import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class BusinessAppearanceSettings extends DataModel {
  static readonly TYPE_ID: string = '56ddc6a91be743a892a63a50e163ccf1';

  constructor(
    public readonly groupServicesByStaffMembers: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessAppearanceSettings.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessAppearanceSettings {
    return new BusinessAppearanceSettings(
        MapUtils.get<boolean>(map, 'groupServicesByStaffMembers'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'groupServicesByStaffMembers': this.groupServicesByStaffMembers,
    };
  }

  clone(): this {
    return new BusinessAppearanceSettings(
        this.groupServicesByStaffMembers,
    ) as this;
  }

  isSame(other: BusinessAppearanceSettings): boolean {
    if(this === other) {
      return true;
    }

    return other.groupServicesByStaffMembers === this.groupServicesByStaffMembers;
  }
}

export class BusinessAppearanceSettingsBuilder extends DataModelBuilder<BusinessAppearanceSettings> {
  build(context: SerializationContext, map: SerializedData): BusinessAppearanceSettings {
    return BusinessAppearanceSettings.fromMap(context, map);
  }
}
